module.exports = __webpack_public_path__ + "img/logo-weis.4032b3b9.svg";